/* eslint-disable react/no-children-prop */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import atatus from 'atatus';

import { generateBarcode } from '../../services/AccountService';

import BarcodeItem from './BarcodeItem';
import { ReactComponent as CloseIcon } from './close-icon.svg';
import DigitalBarcodeError from './DigitalBarcodeError';
import DigitalBarcodeLoading from './DigitalBarcodeLoading';

const DigitalBarcode = (props) => {
    const {
        account: { accountNumber, merchantName },
        handleClose,
    } = props;

    const { locale } = useIntl();
    const [barcode, setBarcode] = useState('');
    const [encryptedBarCode, setEncryptedBarCode] = useState('');
    const [isFetchingBarcode, setIsFetchingBarcode] = useState(true);
    const [error, setError] = useState(null);
    const logo = `/images/fairstone_logo_reversed_${locale}.svg`;
    const closeButton = useRef();

    useEffect(() => {
        let isMounted = true;
        document.addEventListener('keydown', preventTab);
        const getBarcode = async () => {
            atatus.startTransaction('GetBarcode');
            try {
                const { barcode: bCode, encryptedBarCode: eBarCode } = await generateBarcode(accountNumber);
                if (isMounted) {
                    setBarcode(bCode);
                    setEncryptedBarCode(eBarCode);
                }
                atatus.endTransaction('GetBarcode');
            } catch (e) {
                if (isMounted) {
                    setError(true);
                }
                atatus.failTransaction('GetBarcode');
            } finally {
                if (isMounted) {
                    setIsFetchingBarcode(false);
                }
            }
        };
        getBarcode();
        closeButton.current.focus();

        return () => {
            isMounted = false;
            document.removeEventListener('keydown', preventTab);
        };
    }, [accountNumber]);

    const preventTab = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
        }
    };

    const BarcodeModalContent = () => {
        if (error) {
            return <DigitalBarcodeError />;
        }

        if (isFetchingBarcode) {
            return <DigitalBarcodeLoading />;
        }

        return (
            <BarcodeItem
                barcode={barcode}
                encryptedBarCode={encryptedBarCode}
                handleClose={handleClose}
                merchantName={merchantName}
            />
        );
    };

    return (
        <React.Fragment>
            <div className="digital-barcode-header">
                <FormattedMessage
                    children={(msg) => <img alt={msg} className="header-logo" src={logo} />}
                    id="header.logo.alt"
                />
                <button aria-label="Close digital barcode modal" onClick={handleClose} ref={closeButton}>
                    <CloseIcon aria-hidden />
                </button>
            </div>
            <BarcodeModalContent />
        </React.Fragment>
    );
};

export default DigitalBarcode;
